/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/utils/renderUtils.js
 * @Author: Yongchao Wang
 * @Date: 2021-07-21 10:36:30
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2022-06-13 16:05:41
 */

import { Vector3 } from '@babylonjs/core/Maths/math';
import { Matrix } from '@babylonjs/core/Maths/math.vector';
import MeshManage from '../meshManage';
import {
  FRAMECATEGORY,
  SKIRTINGBOARDCONFIG, CORNERDISTANCE, HALFCORNEROUTDISTANCE,
  TYPECODE,
} from './kitchenConfig';
import { BASICTYPE_ENUM } from './enum';
import Refrigerator from '../specialHandler/refrigerator';
/**
 * @description: 添加Mesh加载任务
 * @param {*} assetsManager 素材管理器
 * @param {*} assets 素材列表
 * @param {*} componentAssetsMap 存储不同素材的Map
 * @param {*} needCloneAssetsMap 存储需要clone的素材
 * @return {*}
 * @author: Yongchao Wang
 */
export function addMeshTask(assetsManager, assets, componentAssetsMap, needCloneAssetsMap) {
  if (!assets || !assetsManager) {
    return;
  }
  const needCloneAssetsMapClone = needCloneAssetsMap;
  const componentAssetsMapClone = componentAssetsMap;
  if (!(assets instanceof Array)) {
    const { componentBasic } = assets;

    if (componentBasic.show && componentBasic.modelUrl) {
      const { modelUrl } = componentBasic;
      const splits = modelUrl.split('/');
      const fileName = splits[splits.length - 1];
      const rooturl = process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_OSS : modelUrl.substr(0, modelUrl.length - fileName.length);

      // 如果已经有这个类型的模型了就不再加载，先记录下id后面clone
      // 高柜使用相同模型  不一样的componentid  所以修改为根据模型的modelUrl来判断用不用clone
      if (componentAssetsMap[componentBasic.modelUrl]) {
        needCloneAssetsMapClone[componentBasic.id] = componentAssetsMap[componentBasic.modelUrl];
      } else {
        if (componentBasic.width === 1280) {
          componentAssetsMapClone[componentBasic.id] = componentBasic.id;
        } else {
          componentAssetsMapClone[componentBasic.modelUrl] = componentBasic.id;
        }
        assetsManager.addMeshTask(componentBasic.id, '', rooturl, fileName);
      }
    }
    return;
  }
  assets.forEach((element) => {
    if (!element) {
      return;
    }
    const {
      componentBasic, doors, accessories, sink, ventilator, stove, sidePlates, sealPlate, fridgeArk,
    } = element;
    if (componentBasic?.show && componentBasic?.modelUrl) {
      const { modelUrl } = componentBasic;

      const splits = modelUrl.split('/');
      const fileName = splits[splits.length - 1];
      const rooturl = process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_OSS : modelUrl.substr(0, modelUrl.length - fileName.length);

      // 如果已经有这个类型的模型了就不再加载，先记录下id后面clone,如果是1280转角柜不要clone
      if (componentAssetsMap[componentBasic.modelUrl]) {
        needCloneAssetsMapClone[componentBasic.id] = componentAssetsMap[componentBasic.modelUrl];
      } else {
        if (componentBasic.width === 1280) {
          componentAssetsMapClone[componentBasic.id] = componentBasic.id;
        } else {
          componentAssetsMapClone[componentBasic.modelUrl] = componentBasic.id;
        }

        assetsManager.addMeshTask(componentBasic.id, '', rooturl, fileName);
      }
    } else {
      return;
    }


    if (element?.handle) {
      addMeshTask(assetsManager, element.handle, componentAssetsMap, needCloneAssetsMap);
    }
    if (doors) {
      addMeshTask(assetsManager, doors, componentAssetsMap, needCloneAssetsMap);
    }
    if (accessories) {
      addMeshTask(assetsManager, accessories, componentAssetsMap, needCloneAssetsMap);
    }
    if (sink) {
      addMeshTask(assetsManager, sink, componentAssetsMap, needCloneAssetsMap);
      if (sink.faucet) {
        addMeshTask(assetsManager, sink.faucet, componentAssetsMap, needCloneAssetsMap);
      }
    }
    if (ventilator) {
      addMeshTask(assetsManager, ventilator, componentAssetsMap, needCloneAssetsMap);
    }
    if (stove) {
      addMeshTask(assetsManager, stove, componentAssetsMap, needCloneAssetsMap);
    }
    if (sidePlates) {
      addMeshTask(assetsManager, sidePlates, componentAssetsMap, needCloneAssetsMap);
    }
    if (sealPlate) {
      addMeshTask(assetsManager, sealPlate, componentAssetsMap, needCloneAssetsMap);
    }

    if (fridgeArk) {
      addMeshTask(assetsManager, fridgeArk?.frames, componentAssetsMap, needCloneAssetsMap);
    }
  });
}


export function getReloadAssets(assets, errorList) {
  let resultList = [];
  if (!assets) {
    return resultList;
  }
  if (!(assets instanceof Array)) {
    const { componentBasic } = assets;
    if (componentBasic.show && componentBasic.modelUrl) {
      if (errorList.includes(componentBasic.id)) {
        resultList.push({ componentBasic });
      }
    }
    return resultList;
  }
  assets.forEach((element) => {
    if (!element) {
      return;
    }
    const {
      componentBasic, doors, accessories, sink, ventilator, stove,
    } = element;

    if (componentBasic.show && componentBasic.modelUrl) {
      if (errorList.includes(componentBasic.id)) {
        resultList.push({ componentBasic });
      }
    } else {
      return;
    }


    if (element?.handle) {
      resultList = resultList.concat(getReloadAssets(element.handle, errorList));
    }
    if (doors) {
      resultList = resultList.concat(getReloadAssets(doors, errorList));
    }
    if (accessories) {
      resultList = resultList.concat(getReloadAssets(accessories, errorList));
    }
    if (sink) {
      resultList = resultList.concat(getReloadAssets(sink, errorList));
      if (sink.faucet) {
        resultList = resultList.concat(getReloadAssets(sink.faucet, errorList));
      }
    }
    if (ventilator) {
      resultList = resultList.concat(getReloadAssets(ventilator, errorList));
    }
    if (stove) {
      resultList = resultList.concat(getReloadAssets(stove, errorList));
    }
  });
  return resultList;
}


/**
   * @description: 检查上一个柜子是否是高柜
   * @param {*} frames
   * @param {*} index
   * @return {*}
   * @author: Yongchao Wang
   */
export function checkPreFrameIsHighFrame(frames, index) {
  if (index === 0) {
    return false;
  }
  const frame = frames[index - 1];
  if (frame.categoryId === FRAMECATEGORY.CATEGORY_10
      || frame.categoryId === FRAMECATEGORY.CATEGORY_11
      || frame.categoryId === FRAMECATEGORY.CATEGORY_12
      || frame.categoryId === FRAMECATEGORY.CATEGORY_33
      || frame.categoryId === FRAMECATEGORY.CATEGORY_34
      || frame.categoryId === FRAMECATEGORY.CATEGORY_35
      || frame.categoryId === FRAMECATEGORY.CATEGORY_36
      || frame.categoryId === FRAMECATEGORY.CATEGORY_37
  ) {
    return true;
  }
  return false;
}


/**
   * @description: 检查柜子是否是高柜
   * @param {*} frames
   * @param {*} index
   * @return {*}
   * @author: Yongchao Wang
   */
export function checkFrameIsHighFrame(frame) {
  if (!frame) {
    return false;
  }
  if (frame.categoryId === FRAMECATEGORY.CATEGORY_10
      || frame.categoryId === FRAMECATEGORY.CATEGORY_11
      || frame.categoryId === FRAMECATEGORY.CATEGORY_12
      || frame.categoryId === FRAMECATEGORY.CATEGORY_33
      || frame.categoryId === FRAMECATEGORY.CATEGORY_34
      || frame.categoryId === FRAMECATEGORY.CATEGORY_35
      || frame.categoryId === FRAMECATEGORY.CATEGORY_36
      || frame.categoryId === FRAMECATEGORY.CATEGORY_37
  ) {
    return true;
  }
  return false;
}
/**
   * @description: 1.默认检查柜子是否是转角柜 2. 需要检测的柜子类型id，检测是否是该类型
   * @param {*} frames
   * @return {*}
   * @author: Kun Yang
   */
export function checkFrameIsCornerFrames(frame, frameTypeId = Number(undefined)) {
  if (!frame) {
    return false;
  }

  if (frameTypeId) {
    if (frame.categoryId === frameTypeId) {
      return true;
    }
    return false;
  }

  if (frame.categoryId === FRAMECATEGORY.CATEGORY_8
      || frame.categoryId === FRAMECATEGORY.CATEGORY_9
      || frame.categoryId === FRAMECATEGORY.CATEGORY_27
      || frame.categoryId === FRAMECATEGORY.CATEGORY_28) {
    return true;
  }
  return false;
}

/**
 * @description: 获取底部高柜
 * @param {*} edge
 * @param {*} templatejson
 * @return {*}
 * @author: Yongchao Wang
 */
export function getBottomHighFrame(edge, templatejson) {
  let highFrame;
  templatejson.bottom[edge].frames.forEach((element) => {
    if (checkFrameIsHighFrame(element.componentBasic)) {
      highFrame = element;
    }
  });
  return highFrame;
}

export function toDomPos(pos, scene, camera, engine) {
  return new Vector3.Project(
    new Vector3(pos.x, pos.y, pos.z),
    Matrix.Identity(),
    scene.getTransformMatrix(),
    camera.viewport.toGlobal(
      engine.getRenderingCanvasClientRect().width,
      engine.getRenderingCanvasClientRect().height,
    ),
  );
}

export function getMinMaxVector3(mesh) {
  if (!mesh) {
    return undefined;
  }
  const abstractMesh = mesh.getHierarchyBoundingVectors();
  const bounds = abstractMesh.max.subtract(abstractMesh.min);
  const min = new Vector3(mesh.position.x - bounds.x / 2, mesh.position.y, mesh.position.z - bounds.z / 2);
  const max = new Vector3(mesh.position.x + bounds.x / 2, mesh.position.y, mesh.position.z + bounds.z / 2);
  return { min, max };
}

/**
 * @description: 摆放底柜转角柜
 * @param {*} frame 柜子数据
 * @param {*} preFrame 转角柜长边所在位置
 * @return {*} 返回旋转角度
 * @author: Yongchao Wang
 */
export function putBottomCornerFrame(frame, preFrame, scene) {
  // 当前所在边length1、length2、length3
  const { edge } = frame.componentBasic;
  // 长边所在长度
  const { longEdge } = frame;
  let rotation;
  // 88转角柜
  if (frame.componentBasic.width === 880) {
    if (edge === 'length1') {
      const meshManage = new MeshManage(scene.getMeshByName(frame.componentBasic.id));
      rotation = meshManage.addRotation(0, -Math.PI / 2, 0);
      meshManage.setModelPosition({
        x: -meshManage.getModelSize().z * 0.5,
        y: SKIRTINGBOARDCONFIG.HEIGHT,
        z: meshManage.getModelSize().x * 0.5,
      });
    } else {
      const preMeshManage = new MeshManage(scene.getMeshByName(preFrame.componentBasic.id));
      const meshManage = new MeshManage(scene.getMeshByName(frame.componentBasic.id));
      rotation = meshManage.addRotation(0, -Math.PI, 0);
      const preDatumPoint = preMeshManage.getDatumPoint({ x: 0, y: 1, z: 1 });
      meshManage.setModelPosition({
        x: -meshManage.getModelSize().x * 0.5 + preDatumPoint.x,
        y: preDatumPoint.y,
        z: preDatumPoint.z + meshManage.getModelSize().z * 0.5,
      });
    }
  } else if (longEdge === 1) {
    // 128*68转角柜 右开门 在L1上
    const meshManage = new MeshManage(scene.getMeshByName(frame.componentBasic.id));
    meshManage.setModelPosition({
      x: -meshManage.getModelSize().x * 0.5,
      y: SKIRTINGBOARDCONFIG.HEIGHT,
      z: meshManage.getModelSize().z * 0.5,
    });
  } else if (longEdge === 2 && edge === 'length1') {
    // 128*68转角柜 左开门 在L1上
    const meshManage = new MeshManage(scene.getMeshByName(frame.componentBasic.id));
    rotation = meshManage.addRotation(0, -Math.PI / 2, 0);
    meshManage.setModelPosition({
      x: -meshManage.getModelSize().z * 0.5,
      y: SKIRTINGBOARDCONFIG.HEIGHT,
      z: meshManage.getModelSize().x * 0.5,
    });
  } else if (longEdge === 2 && edge === 'length2') {
    // 128*68转角柜 右开门 在L2上
    const preMeshManage = new MeshManage(scene.getMeshByName(preFrame.componentBasic.id));
    const meshManage = new MeshManage(scene.getMeshByName(frame.componentBasic.id));
    rotation = meshManage.addRotation(0, -Math.PI / 2, 0);
    const preDatumPoint = preMeshManage.getDatumPoint({ x: 0, y: 1, z: 1 });
    meshManage.setModelPosition({
      x: -meshManage.getModelSize().z * 0.5 + preDatumPoint.x,
      y: preDatumPoint.y,
      z: preDatumPoint.z + meshManage.getModelSize().x * 0.5,
    });
  } else {
    // 128*68转角柜 左开门 在L2上
    const preMeshManage = new MeshManage(scene.getMeshByName(preFrame.componentBasic.id));
    const meshManage = new MeshManage(scene.getMeshByName(frame.componentBasic.id));
    rotation = meshManage.addRotation(0, -Math.PI, 0);
    const preDatumPoint = preMeshManage.getDatumPoint({ x: 0, y: 1, z: 1 });
    meshManage.setModelPosition({
      x: -meshManage.getModelSize().x * 0.5 + preDatumPoint.x,
      y: preDatumPoint.y,
      z: preDatumPoint.z + meshManage.getModelSize().z * 0.5,

    });
  }
  return { rotation };
}

/**
 * @description: 获取在128*68转角柜后面放置柜子的基准点
 * @param {*} index
 * @param {*} preEl
 * @return {*}
 * @author: Yongchao Wang
 */
export function getAfterBottomCornerFrameDatumPoint(index, preEl, currentEl, scene) {
  let datumPoint;
  const preMeshManage = new MeshManage(scene.getMeshByName(preEl.componentBasic.id));

  if (index === 1 && preEl.componentBasic.width === 1280 && preEl.longEdge === 2
    && currentEl.componentBasic.edge === 'length1') {
    datumPoint = {
      x: preMeshManage.mesh.position.x + currentEl.getModelSize().x,
      y: preMeshManage.mesh.position.y,
      z: preMeshManage.mesh.position.z - preMeshManage.getModelSize().z / 2,
    };
  }

  return datumPoint;
}

/**
 * @description: 检查是否是摆放在128…*68转角柜后面的
 * @param {*} index 索引
 * @param {*} preEl 上一个柜子
 * @param {*} currentEl 当前柜子
 * @return {*}
 * @author: Yongchao Wang
 */
export function checkIsAfterBottomCornerFrame(index, preEl, currentEl) {
  if (index === 1 && preEl.componentBasic.width === 1280 && preEl.longEdge === 2
    && currentEl.componentBasic.edge === 'length1') {
    return true;
  }

  if (index === 0 && preEl.componentBasic.width === 1280 && preEl.longEdge === 1
    && currentEl.componentBasic.edge === 'length2') {
    return true;
  }
  if (index === 0 && preEl.componentBasic.width === 1280 && preEl.longEdge === 2
    && currentEl.componentBasic.edge === 'length3') {
    return true;
  }
  return false;
}

/**
 * @description: 是否是高柜的上部
 * @param {*} globalName
 * @param {*} categoryId
 * @param {*} index
 * @return {*}
 * @author: Yongchao Wang
 */
export function isHighFrameTopPart(globalName, categoryId, index) {
  // 正常高柜门板是从上到下，但是在调用次方法之前，如果是高柜/全隔板3开门，门板顺序倒一下，后端给的顺序不对
  let isTop = false;// 是否是底部柜门
  switch (categoryId) {
    case FRAMECATEGORY.CATEGORY_10:
    case FRAMECATEGORY.CATEGORY_33:
    case FRAMECATEGORY.CATEGORY_34:
    case FRAMECATEGORY.CATEGORY_35:
    case FRAMECATEGORY.CATEGORY_36:
    case FRAMECATEGORY.CATEGORY_37:
      // 高柜/全隔板3开门 index 0-》2 下柜-》上柜，决定了把手位置， 沃拓普有三门板，非沃拓普只有2个
      if (index === 0) {
        isTop = false;
      } else {
        isTop = true;
      }
      break;
    case FRAMECATEGORY.CATEGORY_11:
      // 高柜/烤箱柜 (一个洞) 上门板 ->三抽屉面板
      if (index < 3) {
        isTop = false;
      } else {
        isTop = true;
      }
      break;

    default:
      // 高柜/微波炉和烤箱柜(两个洞) 上门板 -> 两抽屉面板
      if (index < 2) {
        isTop = false;
      } else {
        isTop = true;
      }
      break;
  }
  return isTop;
}

/**
 * @param {object} {} LengthData 每个边的数据
 * @returns {object} {} 返回最后一个柜体数据
 * @author: Kun Yang
 */
export function getLengthLastFrames(LengthData) {
  const framesList = LengthData?.frames || [];
  let lasetFrames = {};
  // eslint-disable-next-line no-plusplus
  for (let index = framesList.length - 1; index >= 0; index--) {
    if ((!checkFrameIsHighFrame(framesList[index])
      && !checkFrameIsCornerFrames(framesList[index]))
      || framesList.length === 1
    ) {
      lasetFrames = framesList[index];
      index = 0;
    }
  }
  return lasetFrames;
}

/**
 * 获取转角柜上面的对象的  位置信息  X距离边距5cm Y个性化 Z是固定的多出来8cm/2
 * @param {new MeshManager} parent 转角柜对象
 * @param {new MeshManager} child 转角柜上面的物品对象 水槽or燃气灶or吸油烟机
 * @param {string} direction  left or right  转角柜方向即门在左边还是右边
 */
export function getCornerCabinetFrameXZ(parentPosition, parentSize, childSize, direction, lengthDirection, type) {
  let x;
  let z = -HALFCORNEROUTDISTANCE;
  // 如果吸油烟机在转角柜上面  那么parent的定位就是当前定位
  if (type === 'ventilator') {
    if (lengthDirection === 'length1') {
      x = parentPosition.x - parentSize.x / 2 + childSize.x / 2 + CORNERDISTANCE;
      z = parentPosition.z - parentSize.z / 2 + childSize.z / 2;
    } else if (lengthDirection === 'length2') {
      x = parentPosition.x + HALFCORNEROUTDISTANCE + childSize.x / 2;
      if (direction === 'right') {
        // length2 的右转角 即在l3部分
        z = parentPosition.z - parentSize.z / 2 + childSize.x / 2 + CORNERDISTANCE;
      } else {
        // length2 的左转角 即在l1部分
        z = parentPosition.z + parentSize.z / 2 - childSize.x / 2 - CORNERDISTANCE;
      }
    } else {
      x = parentPosition.x - parentSize.x / 2 + childSize.x / 2 + CORNERDISTANCE;
      z = parentPosition.z + parentSize.z / 2 - childSize.z / 2;
    }
  } else {
    if (direction === 'right') {
      x = parentPosition.x + parentSize.x / 2 - childSize.x / 2 - CORNERDISTANCE;
    } else {
      x = parentPosition.x - parentSize.x / 2 + childSize.x / 2 + CORNERDISTANCE;
    }
    if (lengthDirection === 'length3') {
      x = parentPosition.x - parentSize.x / 2 + childSize.x / 2 + CORNERDISTANCE;
      z = parentPosition.z - HALFCORNEROUTDISTANCE;
    }
  }

  return { x, z };
}

/**
 *
 * @param {*} frame
 * @param {*} preFrame
 * @param {*} scene
 * @description 摆放顶部高柜
 */
export function putTopHightFrame(frame, preFrame, sealPlateData, scene, otherSealPlateLength, isTwoFrame) {
  const preMeshManage = new MeshManage(scene.getMeshByName(preFrame.componentBasic.id));
  const meshManage = new MeshManage(scene.getMeshByName(frame.componentBasic.id));
  const sealPlateMesh = new MeshManage(scene.getMeshByName(sealPlateData[0]?.id));
  const sealPlateSizeX = (sealPlateMesh && otherSealPlateLength) || isTwoFrame ? sealPlateMesh.getModelSize().x : 0;
  meshManage.setModelPosition({
    x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5 - meshManage.getModelSize().x * 0.5
       - sealPlateSizeX,
    y: SKIRTINGBOARDCONFIG.HEIGHT,
    z: preMeshManage.mesh.position.z - preMeshManage.getModelSize().z * 0.5 + meshManage.getModelSize().z * 0.5,
  });
}

/**
 *
 * @param {*} frame
 * @param {*} preFrame
 * @param {*} scene
 * @description 摆放顶部高柜
 */
export function renderSealPlatePos(
  scene,
  templateJson,
  lengthSealPlateData,
  exampleObj,
  rotationMeshes,
  preEl,
  preCurrent,
  preMeshManage,
  currentEl,
  current,
  meshManage,
  type,
  lengthType,
) {
  const frameLengthOne = templateJson[type][lengthType]?.frames?.length;
  // const lastLengthOneFrame = templateJson?.bottom?.length1?.frames[frameLengthOne - 1];
  const topLastFram = templateJson[type][lengthType]?.frames?.slice(-1) || [];
  let datumPoint = null;
  let sealPlateMesh = null;

  // const hasLength1HightFrame = checkouHasHightFrame(this?.templateJson, lengthType);

  let longLength = 0;

  const otherSealPlateLength = templateJson[type][lengthType]?.otherSealPlateLength;
  console.log('otherSealPlateLength', type, preCurrent, otherSealPlateLength);
  // console.log('preCurrent', otherSealPlateLength);
  if (type === 'top') {
    // debugger;
  }
  if (
    preCurrent === 0
    && lengthSealPlateData.length
    && !otherSealPlateLength
  ) { // 是否是第一个柜体和加高柜的补板长度为null
    sealPlateMesh = exampleObj.renderSealPlate(
      lengthSealPlateData, preMeshManage, meshManage, type, preEl, rotationMeshes,
    );
    datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
  } else if (
    current === frameLengthOne - 1
    && lengthSealPlateData.length
    && otherSealPlateLength
  ) { // 加高柜的补板长度不为null
    if (checkFrameIsHighFrame(topLastFram)) { // 高柜是否在顶柜
      sealPlateMesh = new MeshManage(scene.getMeshByName(lengthSealPlateData[0].id));

      longLength = preEl?.longEdge === 2 ? preEl.width : 60;
      console.log('longLength', longLength);

      const lastMoveZ = ((preMeshManage.getCenterPosition().z * 2) / (longLength)) * 60;

      sealPlateMesh.setModelPosition({
        x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5 - meshManage.getModelSize().x
          - sealPlateMesh.getModelSize().x * 0.5,
        y: SKIRTINGBOARDCONFIG.HEIGHT,
        // z: preMeshManage.mesh.position.z - preMeshManage.getModelSize().z * 0.5
        //   - sealPlateMesh.getModelSize().z * 0.5,
        z: lastMoveZ - sealPlateMesh.getModelSize().z,
      });

      datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 });
    } else if (otherSealPlateLength && type === 'top') {
      sealPlateMesh = exampleObj.renderSealPlate(
        lengthSealPlateData, preMeshManage, meshManage, type, preEl, rotationMeshes,
      );
      datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
    } else {
      sealPlateMesh = exampleObj.renderSealPlate(
        lengthSealPlateData, preMeshManage, meshManage, type, preEl, rotationMeshes,
      );
      datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
    }
  } else {
    datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 });
  }
  return datumPoint;
}

/**
 * @description: 判断底柜或顶柜里有没有高柜
 * @param {*} templateJson MCC TemplateJson
 * @param {*} position 高柜在底柜还是顶柜
 * @param {*} lengthType 高柜在哪条边
 * @return {*} Boolean 是否有高柜
 * @author: Zhanyu Shen
 */
export function checkHasHightFrameByPosition(templateJson, position, lengthType) {
  let hasHightFrame = false;

  if (templateJson[position]) {
    templateJson[position][lengthType]?.frames.forEach((item) => {
      // name为空为空高柜，旧版数据有空高柜需要排除
      if (!hasHightFrame && item.name) {
        hasHightFrame = checkFrameIsHighFrame(item);
      }
    });
  }
  return hasHightFrame;
}

/**
 * @description: 判断底柜或顶柜里有没有冰箱
 * @param {*} templateJson MCC TemplateJson
 * @param {*} position 冰箱在底柜还是顶柜
 * @param {*} lengthType 冰箱在哪条边
 * @return {*} Boolean 是否有冰箱
 * @author: Zhanyu Shen
 */
export function checkHasRefrigerarorByPosition(templateJson, position, lengthType) {
  let hasRefrigeraror = false;

  if (templateJson[position]) {
    templateJson[position][lengthType]?.frames.forEach((item) => {
      // name为空为空高柜，旧版数据有空高柜需要排除
      if (!hasRefrigeraror && item.name) {
        hasRefrigeraror = Refrigerator.checkFrameIsRefrigeraror(item);
      }
    });
  }
  return hasRefrigeraror;
}

/**
 * @description: 统计底柜或顶柜里高柜总长度
 * @param {*} templateJson MCC TemplateJson
 * @param {*} position 高柜在底柜还是顶柜
 * @param {*} lengthType 高柜在哪条边
 * @return {*} int 高柜数量
 * @author: Zhanyu Shen
 */
export function getHightFrameLengthByPosition(templateJson, position, lengthType) {
  let hightFrameLength = 0;

  if (templateJson[position]) {
    templateJson[position][lengthType]?.frames.forEach((item) => {
      if (item.name && checkFrameIsHighFrame(item)) {
        hightFrameLength += Number(item.width);
      }
    });
  }
  return hightFrameLength;
}

/**
 * @description: 判断底柜或顶柜里有没有高柜
 * @param {*} templateJson MCC TemplateJson
 * @param {*} lengthType 高柜在哪条边
 * @return {*} Boolean 是否有高柜
 * @author: Zhanyu Shen
 */
export function checkouHasHightFrame(templateJson, lengthType) {
  let hasHightFrame = false;
  hasHightFrame = checkHasHightFrameByPosition(templateJson, BASICTYPE_ENUM.bottom, lengthType);
  // 如果底柜里没有高柜，去顶柜中查找是否有高柜
  if (!hasHightFrame) {
    hasHightFrame = checkHasHightFrameByPosition(templateJson, BASICTYPE_ENUM.top, lengthType);
  }
  return hasHightFrame;
}

/**
 * @description: 统计底柜或顶柜里冰箱宽
 * @param {*} templateJson MCC TemplateJson
 * @param {*} position 冰箱在底柜还是顶柜
 * @param {*} lengthType 冰箱在哪条边
 * @return {*} int 冰箱宽
 * @author: Zhanyu Shen
 */
export function getRefrigerarorWidthByPosition(templateJson, position, lengthType) {
  let refrigerarorWidth = 0;
  if (templateJson[position]) {
    templateJson[position][lengthType]?.frames.forEach((item) => {
      if (item.name && Refrigerator.checkFrameIsRefrigeraror(item)) {
        refrigerarorWidth += Number(item.width);
      }
    });
  }
  return refrigerarorWidth;
}

/**
 *
 * @param {*} templateJson
 * @param {*} lengthSideType lenght1|lenght2|lenght3 哪条边
 * @param {*} lengthType bottom|top 顶柜还是地柜
 * @author: Kun Yang
 * @description 获取一条边上的一块门板或者抽屉
 * @returns 默认一条边的一块门板、抽屉
 */
export function getDefaultDoor(templateJson, lengthSideType = 'length1', lengthType = 'bottom') {
  let lists = [];
  let defaultDoor;
  [templateJson?.[lengthType]?.[lengthSideType]?.frames].forEach((frames) => {
    if (!frames) {
      return;
    }

    frames.forEach((element) => {
      lists = !checkFrameIsCornerFrames(element) ? lists.concat(element.doors) : lists;
    });
  });
  lists.forEach((item) => {
    if (defaultDoor) {
      return;
    }
    if (TYPECODE.DOORPLANK(item?.componentBasic.typeCode) || TYPECODE.DRAWER(item?.componentBasic.typeCode)) {
      defaultDoor = item;
    }
  });
  return defaultDoor;
}
/**
 * @param {array} framesData 所有高柜门板数据
 * @param {object} doorData 所有高柜门板数据
 * @param {number} pos 第几个高柜
 * @author: Kun Yang
 * @description 获取更换高柜门板时，第几个柜体门板数据
 * @returns 返回第几个高柜需要更改的门板数据
 */
export function compChangeDoorMap(framesData, doorData, pos) {
  let sum = 0;
  const doorchangeMap = {};
  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < framesData.length; index++) {
    const doorLength = framesData[index]?.doors?.length;
    if (pos === 0) {
      doorchangeMap.old = doorData.old.slice(0, doorLength);
      doorchangeMap.new = doorData.new.slice(0, doorLength);
      break;
    }
    sum += doorLength;
    if (pos === index) {
      sum -= doorLength;
      doorchangeMap.old = doorData.old.slice(sum);
      doorchangeMap.new = doorData.new.slice(sum);
      break;
    }
  }
  return doorchangeMap;
}

/**
 * 图片压缩
 * @param {} base64
 * @param {*} w
 * @param {*} callback
 */
export function compressImg(base64, w = 500, callback) {
  const newImage = new Image();
  // quality 为压缩的像素 越低压缩的越小,图片越模糊
  const quality = 0.8; // 压缩系数0-1之间
  newImage.src = base64;
  let imgWidth; let imgHeight;
  newImage.onload = () => {
    imgWidth = this.width;
    imgHeight = this.height;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w;
        canvas.height = (w * imgHeight) / imgWidth;
      } else {
        canvas.height = w;
        canvas.width = (w * imgWidth) / imgHeight;
      }
    } else {
      canvas.width = imgWidth;
      canvas.height = imgHeight;
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
    const base64 = canvas.toDataURL('image/jpeg', quality); // 压缩语句
    callback({ data: base64 }); // 必须通过回调函数返回，否则无法及时拿到该值
  };
}

